<template>
  <a :key="notification.id" class="text-decoration-none" @click="setReadAndGoTo">
    <v-alert v-model="show" :color="notification.color" :icon="icon"
             border="left"
             colored-border dense
             dismissible
             elevation="4"
             prominent>
      {{ notification.titleText }}
      <div class="body-2">
        {{ notification.contentText }}
      </div>
      <template v-slot:close>
        <v-btn :color="notification.type" icon small @click.stop="setRead">
          <v-icon>mdi mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-alert>
  </a>
</template>

<script>

import notificationApi from "@/api/notification";

export default {
  name: "Notification",
  props: ['notification'],
  data() {
    return {
      show: true,
    }
  },
  computed: {
    icon() {
      switch (this.notification.color) {
        case 'success':
          return 'mdi mdi-check';
        case 'warning':
          return 'mdi mdi-bullhorn-outline';
        case 'error':
          return 'mdi mdi-alert-circle-outline';
        case 'info':
          return 'mdi mdi-format-list-checkbox';
        default:
          return 'mdi mdi-alert-circle-outline';
      }
    },
    link() {
      switch (this.notification.type) {
        case 'SURVEY_OVER_X_MONTHS':
          return {name: 'tenant_create_survey'};
        case 'DUNS_NUMBER_MISSING':
          return {name: 'tenant_financials'};
        case 'TENANT_ADDRESS_MISSING':
          return {name: 'tenant_settings', params: {openModalOnMount: true}};
        case 'NOTICE_EMAIL_SUBSCRIPTIONS':
          return {name: 'userprofile'};
        default:
          return false;
      }

    }
  },
  methods: {
    async setReadAndGoTo() {
      this.setRead();
      await this.$router.push(this.link);
    },
    async setRead() {
      this.$emit('read', this.notification.id)
      try {
        await notificationApi.setRead(this.notification.id);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
